export const BROWSER_ID_LOCAL_STORAGE_KEY = 'browser-id';

export default {};
